export default __webpack_public_path__ + "static/media/SBDO.f5c5e4d7.png";